var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInjected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.373 26.966 h -11.82 C 72.003 12.718 60.245 1.293 45.864 1.293 c -14.382 0 -26.139 11.424 -26.688 25.673 H 5.628 C 2.525 26.966 0 29.491 0 32.594 v 50.485 c 0 3.104 2.525 5.628 5.628 5.628 h 78.745 c 3.104 0 5.628 -2.524 5.628 -5.628 V 67.751 V 47.922 V 32.594 C 90 29.491 87.476 26.966 84.373 26.966 z M 45.864 4.293 c 12.727 0 23.141 10.079 23.688 22.673 H 38.869 v -4.861 c 0 -1.368 0.891 -2.524 1.944 -2.524 h 10.103 c 1.054 0 1.943 1.156 1.943 2.524 c 0 0.829 0.672 1.5 1.5 1.5 s 1.5 -0.671 1.5 -1.5 c 0 -3.046 -2.218 -5.524 -4.943 -5.524 h -3.551 v -2.582 c 0 -0.829 -0.672 -1.5 -1.5 -1.5 s -1.5 0.671 -1.5 1.5 v 2.582 h -3.551 c -2.727 0 -4.944 2.478 -4.944 5.524 v 4.861 H 22.176 C 22.723 14.372 33.137 4.293 45.864 4.293 z M 87 64.751 H 73.388 c -2.942 0 -5.337 -2.395 -5.337 -5.337 v -3.155 c 0 -2.942 2.395 -5.337 5.337 -5.337 H 87 V 64.751 z M 87 47.922 H 73.388 c -4.597 0 -8.337 3.74 -8.337 8.337 v 3.155 c 0 4.597 3.74 8.337 8.337 8.337 H 87 v 15.328 c 0 1.449 -1.179 2.628 -2.628 2.628 H 5.628 C 4.179 85.707 3 84.528 3 83.079 V 32.594 c 0 -1.449 1.179 -2.627 2.628 -2.627 h 78.745 c 1.449 0 2.628 1.179 2.628 2.627 V 47.922 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 79.987 59.337 h -5.641 c -0.828 0 -1.5 -0.672 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 h 5.641 c 0.828 0 1.5 0.672 1.5 1.5 S 80.815 59.337 79.987 59.337 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.943 38.981 h -1 c -0.829 0 -1.5 -0.671 -1.5 -1.5 s 0.671 -1.5 1.5 -1.5 h 1 c 0.829 0 1.5 0.671 1.5 1.5 S 9.771 38.981 8.943 38.981 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76.009 38.981 h -1.916 c -0.828 0 -1.5 -0.671 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 h 1.916 c 0.828 0 1.5 0.671 1.5 1.5 S 76.837 38.981 76.009 38.981 z M 69.303 38.981 h -1.916 c -0.828 0 -1.5 -0.671 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 h 1.916 c 0.828 0 1.5 0.671 1.5 1.5 S 70.131 38.981 69.303 38.981 z M 62.596 38.981 H 60.68 c -0.828 0 -1.5 -0.671 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 h 1.916 c 0.828 0 1.5 0.671 1.5 1.5 S 63.424 38.981 62.596 38.981 z M 55.889 38.981 h -1.916 c -0.828 0 -1.5 -0.671 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 h 1.916 c 0.828 0 1.5 0.671 1.5 1.5 S 56.717 38.981 55.889 38.981 z M 49.183 38.981 h -1.916 c -0.828 0 -1.5 -0.671 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 h 1.916 c 0.828 0 1.5 0.671 1.5 1.5 S 50.011 38.981 49.183 38.981 z M 42.476 38.981 H 40.56 c -0.829 0 -1.5 -0.671 -1.5 -1.5 s 0.671 -1.5 1.5 -1.5 h 1.916 c 0.829 0 1.5 0.671 1.5 1.5 S 43.305 38.981 42.476 38.981 z M 35.77 38.981 h -1.916 c -0.829 0 -1.5 -0.671 -1.5 -1.5 s 0.671 -1.5 1.5 -1.5 h 1.916 c 0.829 0 1.5 0.671 1.5 1.5 S 36.598 38.981 35.77 38.981 z M 29.063 38.981 h -1.916 c -0.829 0 -1.5 -0.671 -1.5 -1.5 s 0.671 -1.5 1.5 -1.5 h 1.916 c 0.829 0 1.5 0.671 1.5 1.5 S 29.892 38.981 29.063 38.981 z M 22.356 38.981 H 20.44 c -0.829 0 -1.5 -0.671 -1.5 -1.5 s 0.671 -1.5 1.5 -1.5 h 1.917 c 0.829 0 1.5 0.671 1.5 1.5 S 23.185 38.981 22.356 38.981 z M 15.649 38.981 h -1.916 c -0.829 0 -1.5 -0.671 -1.5 -1.5 s 0.671 -1.5 1.5 -1.5 h 1.916 c 0.829 0 1.5 0.671 1.5 1.5 S 16.478 38.981 15.649 38.981 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81.8 38.981 h -1 c -0.828 0 -1.5 -0.671 -1.5 -1.5 s 0.672 -1.5 1.5 -1.5 h 1 c 0.828 0 1.5 0.671 1.5 1.5 S 82.628 38.981 81.8 38.981 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjected);
export default __webpack_public_path__ + "static/media/Injected.c918c560e162c33c090c5f9aac843ca9.svg";
export { ForwardRef as ReactComponent };